import * as React from 'react';
import {  map } from 'lodash';
import clipIcon from '../../images/clipIcon.svg'
import DataString from './DataString';
import DatePicker from "react-datepicker";
import { AppealRequests } from '../../apiRequests/AppealRequests';
import { ToastNotificationManager } from '../../infrastructure/ToastNotificationManager';
import { NotificationTypeEnum } from '../../models/NotificationModels';
import { FileViewer } from './FilePanels';
import { Spinner } from './Loader';
import { AccountManagerRequests } from '../../apiRequests/AccountManagerRequests';
import { SettingRequests } from '../../apiRequests/SettingRequests';
import { ServiceObjectTypeNumber } from '../../models/SettingModels';
import ServiceObjectSearch from '../generic/component/ServiceObjectSearch';
import { ServiceObjectAddressLayout } from '../../models/ServiceObjectModels';

interface InputProps {
    type: "tel" | "text" | "string" | "number",
    placeholder?: string,
    onChange: (value: string) => void;
    isRequired?: boolean;
    className?: string;
    autoComplete?: string;
}

interface InputState {
    value: string
}

export default class Input extends React.PureComponent<InputProps, InputState> {
    constructor(props: InputProps) {
        super(props);
        this.state = { value: "" }

        this.Input_onChange = this.Input_onChange.bind(this);
    }

    Input_onChange(value: string) {
        switch (this.props.type) {
            case "tel":
                if (value[0] === "+" && !isNaN(Number(value.substring(1))) && value.length <= 12
                    || value.length <= 11 && !isNaN(Number(value))) {
                    this.setState({ value: value });
                    this.props.onChange(value)
                }
                break;
            default:
                this.setState({ value: value });
                this.props.onChange(value)
                break;
        }
    }



    public render() {
        return (<>
            {this.props.type === "text" ?
                <div className='input__container'>
                    {this.state.value !== "" && <div className='input__placeholder'>{this.props.placeholder !== undefined ? this.props.placeholder : ""}{this.props.isRequired ? "*" : ""}</div>}
                    <textarea className={`input__wrapper ${this.props.type} ${this.props.className}`}
                        style={{ paddingTop: this.state.value === "" ? "" : "36px" }}
                        autoComplete={this.props.autoComplete} placeholder={(this.props.placeholder !== undefined ? this.props.placeholder : "") + `${this.props.isRequired ? "*" : ""}`} value={this.state.value}
                        onChange={(e) => { this.Input_onChange(e.currentTarget.value) }}
                    ></textarea>
                </div>
                :
                <div className='input__container'>
                    {this.state.value !== "" && <div className='input__placeholder'>{this.props.placeholder !== undefined ? this.props.placeholder : ""}{this.props.isRequired ? "*" : ""}</div>}
                    <input className={`input__wrapper ${this.props.type} ${this.props.className}`}
                        style={{ paddingTop: this.state.value === "" ? "" : "36px" }}
                        type={this.props.type} autoComplete={this.props.autoComplete} placeholder={(this.props.placeholder !== undefined ? this.props.placeholder : "") + `${this.props.isRequired ? "*" : ""}`} value={this.state.value}
                        onChange={(e) => { this.Input_onChange(e.currentTarget.value) }}
                    ></input>
                </div>}

        </>
        );
    }
}


interface FileInputProps {
    multiple?: boolean,
    title: string
    onChange: (value: {
        id: string | null;
        name: string | null;
    } | {
        id: string | null;
        name: string | null;
    }[] | null) => void;
    isRequired?: boolean;
    onStartChange?: () => void;
}

interface FileInputState {
    value: string,
    uploadedFiles: {
        id: string | null;
        name: string | null;
    }[];
    inProcess: boolean;
}


export class FileInput extends React.PureComponent<FileInputProps, FileInputState> {
    private readonly inputOpenFileRef: React.RefObject<HTMLInputElement>
    constructor(props: FileInputProps) {
        super(props);
        this.state = { value: "", uploadedFiles: [], inProcess: false }

        this.inputOpenFileRef = React.createRef()
    }

    private apiAppealRequest = new AppealRequests();

    private async FileInput_onClick() {
        if (this.inputOpenFileRef.current !== null) {
            await this.inputOpenFileRef.current.click()

        }

    }

    private async onChange() {
        if (this.props.onStartChange !== undefined)
            await this.props.onStartChange();
        await this.setState({ inProcess: true })
        if (this.inputOpenFileRef.current !== null && this.inputOpenFileRef.current.files !== null) {
            let result: {
                id: string | null;
                name: string | null;

            }[] = []
            let response = await Promise.all(map(this.inputOpenFileRef.current.files, (e, i) => this.apiAppealRequest.UploadAppealClientFile(e.name, e, i)))
            response.forEach(e => {
                if (!e.response.result) {
                    if (this.inputOpenFileRef?.current?.files !== null)
                        ToastNotificationManager.SendToast({
                            type: NotificationTypeEnum.danger,
                            message: `Не удалось загрузить файл ${this.inputOpenFileRef?.current?.files[e.index]?.name || ""}`,
                        });
                }
                else
                    result.push({ id: e.response.data, name: this.inputOpenFileRef?.current?.files !== null && this.inputOpenFileRef?.current?.files[e.index].name !== undefined ? this.inputOpenFileRef?.current?.files[e.index]?.name : `Файл_${e.index}` })
            })
            this.setState({ uploadedFiles: result, inProcess: false })
            if (this.props.multiple)
                this.props.onChange(result)

            else
                this.props.onChange(result[0])
        }
    }

    private ViewerItem_onClose(index: number) {
        let newFiles = this.state.uploadedFiles.slice();
        newFiles.splice(index, 1);
        this.setState({ uploadedFiles: newFiles })
    }

    public render() {
        return (
            <div className='appeal__create_attachments'>
                <input type="file" multiple={this.props.multiple} ref={this.inputOpenFileRef}
                    onChange={() => this.onChange()} style={{ display: "none" }} />
                <div className='appeal__create_attachments_header' onClick={() => this.FileInput_onClick()} >
                    <img src={clipIcon}></img>
                    <div className='value-text--bold'>{this.props.title + `${this.props.isRequired ? "*" : ""}`}</div>
                </div>
                {this.state.inProcess ? <Spinner /> :
                    this.state.uploadedFiles.length === 0 ?
                        <div className='name-passive--8'>{this.props.multiple ? "PDF, JPG, PNG до 8 файлов (общий размер 20 Мбайт)" : "PDF, JPG, PNG файлт"}</div>
                        : <FileViewer data={this.state.uploadedFiles.map(e => e.name as string)} onClose={(index) => { this.ViewerItem_onClose(index) }} />}

            </div>
        );
    }
}


interface DateInputProps {
    onChange: (value: Date | null) => void;
    minDate?: Date | null | undefined;
    maxDate?: Date | null | undefined
    placeholder?: string;
    isRequired?: boolean;
}

interface DateInputState {
    value: Date | null
}


export class DateInput extends React.PureComponent<DateInputProps, DateInputState> {
    constructor(props: DateInputProps) {
        super(props);
        this.state = { value: null }
    }

    public render() {
        return (
            <DatePicker className='date' minDate={this.props.minDate} maxDate={this.props.maxDate} placeholderText={this.props.placeholder + `${this.props.isRequired ? "*" : ""}`} selected={this.state.value} onChange={(value) => { this.setState({ value: value }); this.props.onChange(value) }}></DatePicker>
        );
    }
}


interface CheckboxProps {
    onChange: (value: Date | null) => void;
    title: string,
    isRequired?: boolean;
}

interface CheckboxState {
    value: boolean | null
}


export class Checkbox extends React.PureComponent<CheckboxProps, CheckboxState> {
    constructor(props: CheckboxProps) {
        super(props);
        this.state = { value: null }
    }

    public render() {
        return (
            <DataString title={this.props.title + `${this.props.isRequired ? "*" : ""}`} >
                <div className={`checkbox ${this.state.value && "selected"}`} onClick={() => { this.setState({ value: !this.state.value }) }}>
                    <div></div>
                </div>
            </DataString>
        );
    }
}


interface AddressInputProps {
    isValid: boolean,
    SetServiceObject(serviceObject: ServiceObjectAddressLayout | null): void,
}

interface AddressInputState {
    serviceObjectTypeNumber: ServiceObjectTypeNumber | null;
}


export class AddressInput extends React.PureComponent<AddressInputProps, AddressInputState> {
    constructor(props: AddressInputProps) {
        super(props);
        this.state = {
            serviceObjectTypeNumber: null,
        }
        this.apiAccountManagerRequest = new AccountManagerRequests();
        this.apiSettingRequest = new SettingRequests();

    }

    private apiAccountManagerRequest: AccountManagerRequests;
    private apiSettingRequest: SettingRequests;

    async componentDidMount() {
        this.apiSettingRequest.Init();
        await this.GetInformation();
    }


    private async GetInformation() {
        let result = await
            this.apiSettingRequest.GetServiceObjectTypeNumber();
        if (result.result)
            this.setState({ serviceObjectTypeNumber: result.data, })
        else
            this.setState({ serviceObjectTypeNumber: null, })

    }

    public render() {

        return (
            <ServiceObjectSearch
                serviceObject={null}
                isValid={this.props.isValid}
                serviceObjectTypeNumber={this.state.serviceObjectTypeNumber ? this.state.serviceObjectTypeNumber : undefined}
                SetServiceObject={(e) => { if (e?.serviceObjectType == "Квартира") this.props.SetServiceObject(e); else this.props.SetServiceObject(null) }} />
        );
    }
}


